// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Wrapper--1bC8v","ViewFilter":"ViewFilter--3_kBA","Popover":"Popover--3Cegg","Favourites":"Favourites--3Y17S","Close":"Close--2_umt"};